export default __webpack_public_path__ + "static/media/astrology.ff3cdc1f.jpg";